module.exports = __webpack_public_path__ + "img/aq.ef3ef7db.png";